import React, { useEffect, useState } from 'react';
import { getContact } from '../../../api/contactApi';
import { SubHeading } from '../../../components/ClientPage';
import { images } from '../../../constants';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaClock, FaUtensils } from 'react-icons/fa';

const FindUs = () => {
  const [contact, setContact] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const data = await getContact();
        setContact(data);
      } catch (err) {
        console.error('Error fetching contact info:', err);
      }
    };
    fetchContact();
  }, []);

  // Ensure address, cityName, and countryName exist
  const hasCompletedAddress =
    contact?.address && contact?.cityName && contact?.countryName;

  // Build map URL dynamically (no API key)
  const mapUrl = hasCompletedAddress
    ? `https://www.google.com/maps?q=${encodeURIComponent(
        `${contact.address}, ${contact.cityName}, ${contact.countryName}`
      )}&output=embed`
    : null;

  return (
    <div className="app__bg app__wrapper section__padding" id="contact">
      <div className="app__wrapper_info">
        <SubHeading title={t('footer.contact.title')} />
        <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>
          {t('navbar.contact')}
        </h1>

        <div className="app__wrapper-content">
          {/* Restaurant Name */}
          <p
            className="p__cormorant"
            style={{ color: '#DCCA87', marginBottom: '1rem' }}
          >
            <FaUtensils style={{ marginRight: '8px' }} />
            {contact
              ? contact.restaurantName
              : t('footer.loadingRestaurant')}
          </p>

          {/* Address */}
          <div className="contact__address">
            <p className="p__opensans">
              <FaMapMarkerAlt
                style={{ marginRight: '8px', color: '#DCCA87' }}
              />
              {contact
                ? contact.address
                : t('footer.contact.loadingAddress')}
            </p>

            {contact && (
              <p
                className="p__opensans"
                style={{ marginTop: '0.5rem' }}
              >
                {`${contact.postalCode} ${contact.cityName}, ${contact.stateName}, ${contact.countryName}`}
              </p>
            )}
          </div>

          {/* Opening Hours */}
          <p
            className="p__cormorant"
            style={{ color: '#DCCA87', margin: '2rem 0 1rem' }}
          >
            <FaClock style={{ marginRight: '8px' }} />{' '}
            {t('footer.workingHours.title')}
          </p>
          <p className="p__opensans">
            {t('footer.workingHours.days')}:{' '}
            {contact
              ? contact.openingHours
              : t('footer.workingHours.loadingHours')}
          </p>
        </div>

        {/* Visit Us Button */}
        <button
          type="button"
          className="custom__button"
          style={{ marginTop: '2rem' }}
          onClick={() => {
            if (hasCompletedAddress) {
              const query = encodeURIComponent(
                `${contact.address}, ${contact.cityName}, ${contact.countryName}`
              );
              window.open(
                `https://www.google.com/maps/search/?api=1&query=${query}`,
                '_blank'
              );
            }
          }}
          disabled={!hasCompletedAddress}
        >
          {t('navbar.contact')}
        </button>

        {/* Embedded Google Map */}
        {mapUrl && (
          <div
            style={{
              marginTop: '2.5rem',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            }}
          >
            <iframe
              title="restaurant-map"
              width="100%"
              height="350"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={mapUrl}
            ></iframe>
          </div>
        )}
      </div>

      <div className="app__wrapper_img">
        <img src={images.findus} alt="findus_img" />
      </div>
    </div>
  );
};

export default FindUs;
